import script from "./button.vue?vue&type=script&lang=ts&setup=true"
export * from "./button.vue?vue&type=script&lang=ts&setup=true"

import "./button.vue?vue&type=style&index=0&id=51db5681&lang=less&scoped=true"
import "./button.vue?vue&type=style&index=1&id=51db5681&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51db5681"]])

export default __exports__